module.exports = __webpack_public_path__ + "img/frame5.b31cc777.jpg";